import {
    BoarderResponse,
    LatestReservationResponse,

} from "@/types/service-response";


export default class LatestReservation {
  private constructor(
    readonly id: string,
    readonly createdAt: string,
    readonly date: string,
    readonly boarder: BoarderResponse,
    readonly status:any,
    readonly acceptanceStatus: any
  ) {}


  static createFromResponse(responseData: LatestReservationResponse): LatestReservation {

    return new LatestReservation(
          responseData.id,
          responseData.createdAt,
          responseData.date,
          responseData.boarder,
          responseData.status,
          responseData.acceptanceStatus,
    )
  }

  static createFromResponseList(responseData: LatestReservationResponse[]): LatestReservation[] {
    return responseData.map((item:LatestReservationResponse) => {
      return new LatestReservation(
          item.id,
          item.createdAt,
          item.date,
          item.boarder,
          item.status,
          item.acceptanceStatus,
      )
    })
  }
}